<template>
  <div :class="{ 'category__sub-category': parent }">
    <div class="placeholders" v-if="$store.state.view.isLoading">
      <content-placeholders v-for="i in 10" :key="`placeholder-${i}`">
        <content-placeholders-text :lines="1" />
      </content-placeholders>
    </div>

    <ul
      class="categories"
      :class="`level-${level}`"
      v-if="!$store.state.view.isLoading"
    >
      <li
        class="category"
        v-for="category in parentCategories"
        :key="category.term_id"
        :class="{
          'category--expanded': categoryIsExpanded(category.term_id),
          'category--selected': categoryIsChecked(category),
          'sub-selected': categorySubCategoryIsChecked(category),
        }"
      >
        <div class="expander">
          <input
            type="checkbox"
            :name="`filter--${category.slug}`"
            :id="`filter--${category.slug}`"
            :value="category.term_id"
            :checked="categoryIsChecked(category)"
            @change="setCategory($event, category)"
          />

          <span
            class="category__name"
            :class="{ disabled: categoryIsChecked(category) }"
            @click.stop.prevent="onCategoryNameClick(category)"
          >
            {{ getCategoryName(category.name) }}

            <span class="category__number">{{ category.noom_category_id }}</span>
            <span class="category__count" v-if="displayCount !== '0'">
              ({{ category.count }})
            </span>
          </span>

          <label :for="`filter--${category.slug}`">
            <img
              v-if="category.parent === 0 && category.thumbnail_url"
              :src="category.thumbnail_url || default_url"
              alt=""
            />
          </label>

          <button
            class="expander__helper expander__helper--no-sub"
            v-if="!subCategories(category).length"
          ></button>

          <button
            class="expander__helper expander__helper--collapsed"
            @click="addExpanded(category.term_id)"
            v-else-if="!categoryIsExpanded(category.term_id)"
          ></button>

          <button
            class="expander__helper expander__helper--expanded"
            @click="removeExpanded(category.term_id)"
            v-else-if="categoryIsExpanded(category.term_id)"
          ></button>
        </div>

        <tree-view
          v-if="
            categoryChildrenIsSelected(category) ||
            (categoryIsExpanded(category.term_id) && subCategories(category).length)
          "
          :categories="subCategories(category)"
          :parent="category.term_id"
          :level="level + 1"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "tree-view",
  props: {
    title: String,
    parent: Number,
    categories: Array,
    level: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isManual: false,
      expandedCategories: [],
      expandedParentCategories: this.getActiveCategoryParents(),
      displayCount: ws_vue_store.display_taxonomy_count,
    };
  },
  computed: {
    parentCategories() {
      if (this.$store.state.categories.length === 0) {
        return [];
      }

      let filtered = this.$store.state.categories.filter(
        (category) => category.parent === this.parent
      );

      return filtered.filter(
        (thing, index, self) => index === self.findIndex((t) => t.term_id === thing.term_id)
      );
    },
  },
  methods: {
    onCategoryNameClick(category) {
      if (!this.$store.state.onlySidebar && this.categoryIsChecked(category)) return;

      const checkbox = document.getElementById(`filter--${category.slug}`);
      if (checkbox) checkbox.click();
    },
    getCategoryName(name) {
      // Convert special characters from HTML entity codes to characters
      let input = document.createElement("textarea");
      input.innerHTML = name;
      return input.value;
    },
    getActiveCategoryParents() {
      let parentIds = [];
      let activeCategories = this.$store.state.filters.current["product_cat"];
      let allCategories = this.$store.state.categories;

      if (activeCategories instanceof Array && activeCategories.length) {
        for (const activeID of activeCategories) {
          let categoryData = allCategories.find((e) => e.term_id === activeID);
          while (categoryData !== undefined) {
            if (categoryData.parent !== 0) {
              parentIds.push(categoryData.parent);
              categoryData = allCategories.find((e) => e.term_id === categoryData.parent);
            } else {
              break;
            }
          }
        }
      }

      return parentIds;
    },
    addExpanded(termId) {
      this.isManual = true;
      this.expandedCategories.push(termId);
    },
    removeExpanded(termId) {
      this.isManual = true;
      this.expandedCategories = this.expandedCategories.filter((expanded) => expanded !== termId);
    },
    subCategories(category) {
      return this.$store.state.categories.filter(
        (filterCategory) => filterCategory.parent === category.term_id
      );
    },
    categoryIsExpanded(termId) {
      return (
        this.expandedCategories.includes(termId) ||
        this.expandedParentCategories.includes(termId) ||
        (this.$store.state.filters.current["product_cat"] &&
          this.$store.state.filters.current["product_cat"].includes(termId))
      );
    },
    categoryIsChecked(category) {
      return (
        this.$store.state.filters.current[category.taxonomy] &&
        this.$store.state.filters.current[category.taxonomy].includes(category.term_id)
      );
    },
    categorySubCategoryIsChecked(category) {
      return this.expandedParentCategories.includes(category.term_id);
    },
    categoryChildrenIsSelected(category) {
      if (this.isManual) {
        return false;
      }
      if (
        !this.subCategories(category).length ||
        this.$store.state.filters.current[category.taxonomy] === undefined
      ) {
        return false;
      }
      const selected = this.subCategories(category).some((subCategory) =>
        this.$store.state.filters.current[subCategory.taxonomy].includes(subCategory.term_id)
      );
      let subcategory = false;
      category.children.forEach((childrenCategory) => {
        let foundCategory = this.$store.state.categories.find(
          (category) => category.term_id == childrenCategory
        );
        if (foundCategory) {
          let currentCategory = foundCategory.children.some((childTermId) =>
            this.$store.state.filters.current[category.taxonomy].some(
              (filterTermId) => filterTermId === childTermId
            )
          );
          if (currentCategory) subcategory = true;
        }
      });

      if (selected || subcategory) {
        this.addExpanded(category.term_id);
      }
      return selected;
    },
    setCategory(event, category) {
      if (this.$store.state.onlySidebar) {
        let singleProductActiveCategoryClick = document.body.classList.contains('single-product') && event.target.nextElementSibling.classList.contains('disabled');
        if (event.target.checked || singleProductActiveCategoryClick) {
          if (this.subCategories(category).length) {
            this.addExpanded(category.term_id);
          } else {
            window.location.href = this.$store.getters.getCategoryPath(category.term_id);
          }
        } else {
          if (this.categoryIsExpanded(category.term_id)) {
            this.removeExpanded(category.term_id);
          }
        }
        return;
      }

      const isAlreadyChecked = this.categoryIsChecked(category);
      if (isAlreadyChecked && event.target.checked) {
        event.preventDefault();
        return;
      }

      if (ws_vue_store.remove_search_mode_after_click == "1") {
        this.$store.commit("changeSearchMode", false);
        this.$store.state.filters.keyword = "";
        document.dispatchEvent(new Event("ws-clearSearch"));
      }

      this.expandedCategories = [];
      if (event.target.checked) {
        this.$store.commit("setCategoryAllowedAttributes", category.store_attributes);
        this.$store.dispatch("addFilter", {
          taxonomy: category.taxonomy,
          option: category.term_id,
        });
        this.activeIdsWithParents = this.getActiveCategoryParents();
        if (this.subCategories(category).length) {
          this.addExpanded(category.term_id);
        }
        return;
      }

      if (this.categoryIsExpanded(category.term_id)) {
        this.removeExpanded(category.term_id);
      }

      this.$store.commit(
        "setCategoryAllowedAttributes",
        Array.from(ws_vue_store.frontpage_attribute_order)
      );
      this.$store.dispatch("removeFilter", {
        taxonomy: category.taxonomy,
        option: category.term_id,
      });
      this.activeIdsWithParents = this.getActiveCategoryParents();
    },
  },
};
</script>

<style lang="scss" scoped>
.categories {
  .category {
    margin: 0.5rem 0;

    .expander {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      label {
        &.faded {
          pointer-events: none;
          opacity: 0.3;
        }

        input {
          display: none;
        }
      }

      &__helper {
        margin-left: 1rem;

        &--no-sub,
        &--collapsed,
        &--expanded {
          height: 2rem;
          width: 2rem;
          border-radius: 10rem;
          display: inline-flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          padding: 0;
          line-height: 1;
          font-size: 0;
          position: relative;
        }

        &--collapsed,
        &--expanded {
          &:before {
            content: "";
            width: 1rem;
            height: 0.2rem;
            display: block;
          }
        }

        &--collapsed {
          color: $expander-color-secondary;

          &:after {
            content: "";
            width: 0.2rem;
            height: 1rem;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}
</style>
